module.exports = __webpack_public_path__ + "static/media/loader.b8fd85d2.svg";